// マイク・イヤホンのチェック（画面の動き）
// - 外部サーバーは使わない。音声はこのページの中だけで扱い、送信も保存もしない
// - chrome.* は拡張のときだけ使う（無ければ localStorage）。同じ3ファイル（check.html / check.css / check.js）を
//   ショップのページにそのまま置いても動くようにしてある
(() => {
  'use strict';

  const $ = (id) => document.getElementById(id);

  // ---------- ショップへのリンク（補助の位置に1つだけ） ----------
  // 有線イヤホンのコレクション（Shopify 担当が 2026-10-28 に作成。docs/to_shopify.md）
  const SHOP_BASE = 'https://shop.leaf-craft.com/collections/wired-earphones';
  const isExtension = typeof chrome !== 'undefined' && !!(chrome.runtime && chrome.runtime.id);
  {
    const url = new URL(SHOP_BASE);
    if (isExtension) {
      const brands = navigator.userAgentData && navigator.userAgentData.brands;
      const isEdge = brands ? brands.some((b) => b.brand === 'Microsoft Edge') : /\bEdg\//.test(navigator.userAgent);
      url.searchParams.set('utm_source', isEdge ? 'edge_extension' : 'chrome_extension');
      url.searchParams.set('utm_medium', 'extension');
      url.searchParams.set('utm_campaign', 'mic_check');
    }
    $('shop-link').href = url.toString();
  }

  // ---------- 設定の保存（選んだ機器・音の大きさだけ） ----------
  const store = {
    async get() {
      try {
        if (isExtension && chrome.storage && chrome.storage.local) {
          return (await chrome.storage.local.get('settings')).settings || {};
        }
        return JSON.parse(localStorage.getItem('micCheckSettings') || '{}');
      } catch (_) { return {}; }
    },
    async set(patch) {
      Object.assign(settings, patch);
      try {
        if (isExtension && chrome.storage && chrome.storage.local) {
          await chrome.storage.local.set({ settings });
        } else {
          localStorage.setItem('micCheckSettings', JSON.stringify(settings));
        }
      } catch (_) { /* 保存できなくても動作には影響しない */ }
    },
  };
  let settings = {};

  // ---------- 音の土台 ----------
  let ctx = null;       // AudioContext（最初のボタン操作で作る）
  let master = null;    // イヤホンの音の大きさ
  function getCtx() {
    if (!ctx) {
      ctx = new (window.AudioContext || window.webkitAudioContext)({ latencyHint: 'interactive' });
      master = ctx.createGain();
      master.gain.value = volumeToGain($('volume').value);
      master.connect(ctx.destination);
      applyOutputDevice();
    }
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
  }
  function volumeToGain(v) {
    const x = Math.max(0, Math.min(100, Number(v))) / 100;
    return 0.5 * Math.pow(x, 1.5); // 50% で約 0.18。最初は小さめから
  }

  // ---------- 機器の一覧 ----------
  const micSelect = $('mic-select');
  const outSelect = $('out-select');

  function fillSelect(select, list, chosen, word) {
    const before = select.value;
    select.innerHTML = '';
    if (!list.length) {
      select.add(new Option(`いつもの${word}`, ''));
      return;
    }
    list.forEach((d, i) => {
      const label = d.label || (d.deviceId === 'default' ? `いつもの${word}` : `${word} ${i + 1}`);
      select.add(new Option(label, d.deviceId));
    });
    const want = chosen || before;
    if (want && [...select.options].some((o) => o.value === want)) select.value = want;
  }

  async function refreshDevices() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return;
    let devices = [];
    try { devices = await navigator.mediaDevices.enumerateDevices(); } catch (_) { return; }
    fillSelect(micSelect, devices.filter((d) => d.kind === 'audioinput'), settings.micId, 'マイク');
    fillSelect(outSelect, devices.filter((d) => d.kind === 'audiooutput'), settings.outId, '出力先');
  }

  async function applyOutputDevice() {
    const id = outSelect.value;
    const sinkId = id === 'default' ? '' : id;
    try {
      if (ctx && typeof ctx.setSinkId === 'function') await ctx.setSinkId(sinkId);
    } catch (_) { /* 選べない出力先なら、いつもの出力先のまま */ }
    try {
      if (typeof recAudio.setSinkId === 'function') await recAudio.setSinkId(sinkId);
    } catch (_) { /* 同上 */ }
  }

  micSelect.addEventListener('change', async () => {
    await store.set({ micId: micSelect.value });
    if (mic.stream) { stopMic(); await startMic(); } // 使っている最中なら、選び直した機器で始め直す
  });
  outSelect.addEventListener('change', async () => {
    await store.set({ outId: outSelect.value });
    applyOutputDevice();
  });
  $('volume').addEventListener('input', (e) => {
    if (master) master.gain.setTargetAtTime(volumeToGain(e.target.value), ctx.currentTime, 0.02);
  });
  $('volume').addEventListener('change', (e) => store.set({ volume: Number(e.target.value) }));

  // ======================================================================
  // 1. マイク
  // ======================================================================
  const micToggle = $('mic-toggle');
  const micStatus = $('mic-status');
  const meterFill = $('meter-fill');
  const meterPeak = $('meter-peak');
  const wave = $('wave');
  const verdict = $('mic-verdict');
  const recBtn = $('rec-btn');
  const recStatus = $('rec-status');
  const recAudio = $('rec-audio');
  const monitor = $('monitor');

  const mic = { stream: null, source: null, analyser: null, monitorGain: null, raf: 0, startedAt: 0 };
  const recent = []; // 直近の { t, peak, clip } を 2 秒ぶん

  function setStatus(text, isError) {
    micStatus.textContent = text;
    micStatus.classList.toggle('error', !!isError);
  }

  async function startMic() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setStatus('このブラウザではマイクを使えません。', true);
      return;
    }
    const id = micSelect.value;
    const constraints = {
      audio: {
        deviceId: id ? { ideal: id } : undefined,
        // マイクの素の状態を見たいので、加工（エコー除去・ノイズ抑制・自動音量）は切る
        echoCancellation: false,
        noiseSuppression: false,
        autoGainControl: false,
      },
    };
    micToggle.disabled = true;
    setStatus('マイクの許可を待っています…');
    let stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia(constraints);
    } catch (e) {
      micToggle.disabled = false;
      setStatus(micErrorText(e), true);
      return;
    }
    const c = getCtx();
    mic.stream = stream;
    mic.source = c.createMediaStreamSource(stream);
    mic.analyser = c.createAnalyser();
    mic.analyser.fftSize = 2048;
    mic.analyser.smoothingTimeConstant = 0;
    mic.monitorGain = c.createGain();
    mic.monitorGain.gain.value = monitor.checked ? 1 : 0;
    mic.source.connect(mic.analyser);
    mic.source.connect(mic.monitorGain);
    mic.monitorGain.connect(c.destination);
    mic.startedAt = performance.now();
    recent.length = 0;

    const track = stream.getAudioTracks()[0];
    track.addEventListener('ended', () => { if (mic.stream === stream) { stopMic(); setStatus('マイクが外れたか、使えなくなりました。', true); } });

    // 許可が下りると機器の名前が読めるようになるので、一覧を作り直す
    await refreshDevices();
    const actual = track.getSettings && track.getSettings().deviceId;
    if (actual && [...micSelect.options].some((o) => o.value === actual)) micSelect.value = actual;

    micToggle.disabled = false;
    micToggle.textContent = 'マイクのチェックを止める';
    micToggle.classList.add('is-on');
    recBtn.disabled = false;
    monitor.disabled = false;
    setStatus(`使っているマイク：${track.label || 'いつものマイク'}　— 話しかけてみてください。`);
    loop();
  }

  function stopMic() {
    cancelAnimationFrame(mic.raf);
    mic.raf = 0;
    if (recorder && recorder.state !== 'inactive') { try { recorder.stop(); } catch (_) {} }
    if (mic.stream) mic.stream.getTracks().forEach((t) => t.stop());
    if (mic.source) { try { mic.source.disconnect(); } catch (_) {} }
    if (mic.monitorGain) { try { mic.monitorGain.disconnect(); } catch (_) {} }
    mic.stream = mic.source = mic.analyser = mic.monitorGain = null;
    micToggle.textContent = 'マイクのチェックを始める';
    micToggle.classList.remove('is-on');
    micToggle.disabled = false;
    recBtn.disabled = true;
    monitor.disabled = true;
    meterFill.style.width = '0';
    meterPeak.style.opacity = '0';
    verdict.textContent = '';
    verdict.className = 'verdict';
    setStatus('止めました。もう一度「始める」で再開できます。');
    clearWave();
  }

  function micErrorText(e) {
    const name = e && e.name;
    if (name === 'NotAllowedError' || name === 'SecurityError') {
      return 'マイクの使用が許可されませんでした。アドレスバーの左のアイコンから「マイク」を「許可」にして、ページを読み込み直してください（下の「困ったとき」にも手順があります）。';
    }
    if (name === 'NotFoundError' || name === 'OverconstrainedError') {
      return 'マイクが見つかりません。マイクやヘッドセットがつながっているか確かめてください。';
    }
    if (name === 'NotReadableError' || name === 'AbortError') {
      return 'マイクを開けませんでした。ほかのアプリ（Zoom・Discord など）が使っている最中かもしれません。そちらを閉じて、もう一度お試しください。';
    }
    return 'マイクを開けませんでした。機器のつなぎ直しや、ページの読み込み直しをお試しください。';
  }

  micToggle.addEventListener('click', () => (mic.stream ? stopMic() : startMic()));

  // ---- メーター・波形・目安 ----
  const buf = new Float32Array(2048);
  let peakHold = 0;
  let lastVerdictKey = '';

  function loop() {
    if (!mic.analyser) return;
    mic.analyser.getFloatTimeDomainData(buf);
    let peak = 0, sum = 0, clip = 0;
    for (let i = 0; i < buf.length; i++) {
      const v = buf[i];
      const a = v < 0 ? -v : v;
      if (a > peak) peak = a;
      if (a >= 0.985) clip++;
      sum += v * v;
    }
    const rms = Math.sqrt(sum / buf.length);
    const now = performance.now();
    recent.push({ t: now, peak, clip });
    while (recent.length && now - recent[0].t > 2000) recent.shift();

    // メーター：-60〜0 dB を 0〜100% に
    const db = 20 * Math.log10(Math.max(rms, 1e-6));
    const pct = Math.max(0, Math.min(100, (db + 60) / 60 * 100));
    meterFill.style.width = pct + '%';

    // ピークの線（ゆっくり落ちる）
    const peakDb = 20 * Math.log10(Math.max(peak, 1e-6));
    const peakPct = Math.max(0, Math.min(100, (peakDb + 60) / 60 * 100));
    peakHold = Math.max(peakPct, peakHold - 0.6);
    meterPeak.style.left = `calc(${peakHold}% - 2px)`;
    meterPeak.style.opacity = peakHold > 1 ? '0.7' : '0';

    drawWave();
    updateVerdict(now);
    mic.raf = requestAnimationFrame(loop);
  }

  function updateVerdict(now) {
    const elapsed = now - mic.startedAt;
    let maxPeak = 0, clips = 0;
    for (const h of recent) { if (h.peak > maxPeak) maxPeak = h.peak; clips += h.clip; }
    let key, text, cls;
    if (elapsed < 1500) {
      key = 'wait'; text = '声を拾えるか見ています。マイクに向かって、いつもの声で話してみてください。'; cls = '';
    } else if (maxPeak < 0.003) {           // 約 -50 dB より小さい
      key = 'none'; text = 'まだ音が入っていません。マイクに向かって話しても動かないときは、上の「使うマイク」で別のマイクを選ぶか、下の「困ったとき」を見てください。'; cls = 'warn';
    } else if (clips > 20 || maxPeak > 0.85) { // 実際に割れているか、割れる手前まで振れている
      key = 'clip'; text = '大きすぎます。相手には割れて聞こえることがあります。マイクを少し口から離すか、パソコンのマイクの音量を下げてみてください。'; cls = 'warn';
    } else if (maxPeak < 0.05) {            // 約 -26 dB より小さい
      key = 'low'; text = '音は入っていますが、小さめです。話している最中なら、マイクを口に近づけるか、パソコンのマイクの音量を上げてみてください。'; cls = '';
    } else {
      key = 'ok'; text = 'ちょうどよい大きさで声を拾っています。'; cls = 'ok';
    }
    if (key !== lastVerdictKey) {
      lastVerdictKey = key;
      verdict.textContent = text;
      verdict.className = 'verdict' + (cls ? ' ' + cls : '');
    }
  }

  function drawWave() {
    const dpr = window.devicePixelRatio || 1;
    const w = wave.clientWidth, h = wave.clientHeight;
    if (wave.width !== Math.round(w * dpr) || wave.height !== Math.round(h * dpr)) {
      wave.width = Math.round(w * dpr);
      wave.height = Math.round(h * dpr);
    }
    const g = wave.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, w, h);
    g.strokeStyle = '#d9ded9';
    g.lineWidth = 1;
    g.beginPath(); g.moveTo(0, h / 2); g.lineTo(w, h / 2); g.stroke();
    g.strokeStyle = '#2e7d4f';
    g.lineWidth = 1.5;
    g.beginPath();
    const n = buf.length;
    for (let i = 0; i < n; i++) {
      const x = (i / (n - 1)) * w;
      const y = h / 2 - buf[i] * (h / 2 - 2);
      if (i === 0) g.moveTo(x, y); else g.lineTo(x, y);
    }
    g.stroke();
  }

  function clearWave() {
    const g = wave.getContext('2d');
    g.setTransform(1, 0, 0, 1, 0, 0);
    g.clearRect(0, 0, wave.width, wave.height);
  }

  // ---- 録音して聞き返す（このページの中だけ。どこにも残さない） ----
  let recorder = null;
  let recUrl = null;
  const REC_SECONDS = 5;

  recBtn.addEventListener('click', () => {
    if (!mic.stream || (recorder && recorder.state === 'recording')) return;
    if (typeof MediaRecorder === 'undefined') { recStatus.textContent = 'このブラウザでは録音できません。'; return; }
    const chunks = [];
    try {
      recorder = new MediaRecorder(mic.stream);
    } catch (_) { recStatus.textContent = '録音を始められませんでした。'; return; }
    recorder.ondataavailable = (e) => { if (e.data && e.data.size) chunks.push(e.data); };
    recorder.onstop = () => {
      if (!chunks.length) { recStatus.textContent = '録音できませんでした。'; recBtn.disabled = !mic.stream; return; }
      const blob = new Blob(chunks, { type: recorder.mimeType || 'audio/webm' });
      if (recUrl) URL.revokeObjectURL(recUrl);
      recUrl = URL.createObjectURL(blob);
      recAudio.src = recUrl;
      recAudio.hidden = false;
      recStatus.textContent = '再生します。自分の声がどう聞こえるか確かめてください。';
      recAudio.play().catch(() => { recStatus.textContent = '▶ を押すと聞き返せます。'; });
      recBtn.disabled = !mic.stream;
    };
    recorder.start();
    recBtn.disabled = true;
    recAudio.pause();
    let left = REC_SECONDS;
    recStatus.textContent = `録音中… あと ${left} 秒。話してください。`;
    const timer = setInterval(() => {
      left -= 1;
      if (left <= 0) {
        clearInterval(timer);
        if (recorder && recorder.state === 'recording') recorder.stop();
      } else {
        recStatus.textContent = `録音中… あと ${left} 秒。話してください。`;
      }
    }, 1000);
  });

  // ---- 自分の声をイヤホンで聴く（返し） ----
  monitor.addEventListener('change', () => {
    if (!mic.monitorGain) return;
    mic.monitorGain.gain.setTargetAtTime(monitor.checked ? 1 : 0, ctx.currentTime, 0.02);
  });

  // ======================================================================
  // 2. イヤホン・ヘッドホン
  // ======================================================================
  const sideButtons = [...document.querySelectorAll('.side')];
  const altBtn = $('alt-btn');
  const sweepBtn = $('sweep-btn');
  const stopBtn = $('stop-btn');
  const sweepBox = $('sweep');
  const sweepFill = $('sweep-fill');
  const sweepNow = $('sweep-now');

  let playing = null; // { nodes: [], timers: [], raf }

  function stopPlaying() {
    if (!playing) return;
    const c = ctx;
    const t = c.currentTime;
    for (const n of playing.nodes) {
      try {
        if (n.gain) { n.gain.cancelScheduledValues(t); n.gain.setTargetAtTime(0, t, 0.01); }
        if (n.stop) n.stop(t + 0.08);
      } catch (_) {}
    }
    playing.timers.forEach(clearTimeout);
    cancelAnimationFrame(playing.raf);
    playing = null;
    sideButtons.forEach((b) => b.classList.remove('is-playing'));
    stopBtn.hidden = true;
    sweepBox.hidden = true;
  }

  // 短いチャイム（ド→ミ）を、指定の位置（-1 左 … 0 中央 … +1 右）で鳴らす
  function chime(pan, at) {
    const c = ctx;
    const panner = c.createStereoPanner();
    panner.pan.value = pan;
    panner.connect(master);
    const notes = [[523.25, 0, 0.3], [659.25, 0.32, 0.5]];
    const nodes = [panner];
    for (const [freq, offset, dur] of notes) {
      const osc = c.createOscillator();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const g = c.createGain();
      const t0 = at + offset;
      g.gain.setValueAtTime(0, t0);
      g.gain.linearRampToValueAtTime(1, t0 + 0.015);
      g.gain.setValueAtTime(1, t0 + dur - 0.08);
      g.gain.linearRampToValueAtTime(0, t0 + dur);
      osc.connect(g);
      g.connect(panner);
      osc.start(t0);
      osc.stop(t0 + dur + 0.05);
      nodes.push(osc, g);
    }
    return nodes;
  }

  const PAN = { left: -1, center: 0, right: 1 };

  function playSides(sequence) {
    // sequence: [{ side, dur }]
    const c = getCtx();
    stopPlaying();
    const start = c.currentTime + 0.05;
    const nodes = [], timers = [];
    let t = 0;
    for (const step of sequence) {
      nodes.push(...chime(PAN[step.side], start + t));
      const btn = sideButtons.find((b) => b.dataset.side === step.side);
      const from = t;
      timers.push(setTimeout(() => {
        sideButtons.forEach((b) => b.classList.toggle('is-playing', b === btn));
      }, from * 1000));
      t += step.dur;
    }
    timers.push(setTimeout(stopPlaying, (t + 0.3) * 1000));
    playing = { nodes, timers, raf: 0 };
    stopBtn.hidden = false;
  }

  sideButtons.forEach((b) => {
    b.addEventListener('click', () => {
      const side = b.dataset.side;
      playSides([{ side, dur: 1.0 }, { side, dur: 1.0 }]);
    });
  });

  altBtn.addEventListener('click', () => {
    playSides([
      { side: 'left', dur: 1.0 }, { side: 'right', dur: 1.0 },
      { side: 'left', dur: 1.0 }, { side: 'right', dur: 1.0 },
    ]);
  });

  // 低い音から高い音まで（約 10 秒）。高い音ほど耳に刺さるので、上に行くほど少し小さくする
  const SWEEP_FROM = 40, SWEEP_TO = 16000, SWEEP_SECONDS = 10;

  sweepBtn.addEventListener('click', () => {
    const c = getCtx();
    stopPlaying();
    const t0 = c.currentTime + 0.05;
    const t1 = t0 + SWEEP_SECONDS;
    const osc = c.createOscillator();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(SWEEP_FROM, t0);
    osc.frequency.exponentialRampToValueAtTime(SWEEP_TO, t1);
    const g = c.createGain();
    g.gain.setValueAtTime(0, t0);
    g.gain.linearRampToValueAtTime(1, t0 + 0.2);
    g.gain.setValueAtTime(1, t0 + SWEEP_SECONDS * 0.45);
    g.gain.exponentialRampToValueAtTime(0.3, t1 - 0.1);
    g.gain.linearRampToValueAtTime(0, t1);
    osc.connect(g);
    g.connect(master);
    osc.start(t0);
    osc.stop(t1 + 0.05);

    sideButtons.forEach((b) => b.classList.add('is-playing'));
    sweepBox.hidden = false;
    stopBtn.hidden = false;
    playing = { nodes: [osc, g], timers: [], raf: 0 };
    playing.timers.push(setTimeout(stopPlaying, (SWEEP_SECONDS + 0.3) * 1000));

    const tick = () => {
      if (!playing) return;
      const frac = Math.max(0, Math.min(1, (c.currentTime - t0) / SWEEP_SECONDS));
      sweepFill.style.width = frac * 100 + '%';
      const hz = SWEEP_FROM * Math.pow(SWEEP_TO / SWEEP_FROM, frac);
      sweepNow.textContent = `いま ${Math.round(hz).toLocaleString('ja-JP')} Hz`;
      playing.raf = requestAnimationFrame(tick);
    };
    tick();
  });

  stopBtn.addEventListener('click', stopPlaying);

  // ---- どう聞こえたか → 次にやること ----
  const ADVICE = {
    both: {
      cls: '',
      title: '左右とも鳴っています。',
      items: [
        '上の「低い音から高い音まで」も聞いてみて、途中で途切れたりガサガサしたりしなければ問題ありません。',
        'まだなら、1 のマイクも確かめておきましょう。',
      ],
    },
    left: {
      cls: 'warn',
      title: '右が聞こえていません。',
      items: [
        'プラグをいちど抜いて、奥までしっかり差し直してください。少し浮いているだけで片方が消えることがあります。',
        'パソコンのサウンド設定で、左右のバランスが片方に寄っていないか確かめてください。',
        '別のスマホやパソコンにつないでも同じ側が鳴らないなら、イヤホン側の問題です。',
        'ケーブルの根元を軽く曲げて音が出たり消えたりするなら、ケーブルの中の線が傷んでいる可能性があります。',
      ],
    },
    right: {
      cls: 'warn',
      title: '左が聞こえていません。',
      items: [
        'プラグをいちど抜いて、奥までしっかり差し直してください。少し浮いているだけで片方が消えることがあります。',
        'パソコンのサウンド設定で、左右のバランスが片方に寄っていないか確かめてください。',
        '別のスマホやパソコンにつないでも同じ側が鳴らないなら、イヤホン側の問題です。',
        'ケーブルの根元を軽く曲げて音が出たり消えたりするなら、ケーブルの中の線が傷んでいる可能性があります。',
      ],
    },
    none: {
      cls: 'warn',
      title: '音が出ていません。',
      items: [
        '上の「音を出す先」で別の出力先を選んで、もう一度鳴らしてみてください。パソコンのスピーカーから鳴るなら、つなぎ方の問題です。',
        '「音の大きさ」とパソコンの音量が、ゼロや消音になっていないか確かめてください。',
        'Bluetooth のイヤホンは、別のスマホにつながったままのことがあります。',
        'プラグを差し直し、別のスマホやパソコンでも鳴らないならイヤホン側の問題です。',
        'それでも直らないときは、下の「困ったとき」を機器ごとに見てください。',
      ],
    },
  };

  const advice = $('advice');
  document.querySelectorAll('.result').forEach((b) => {
    b.addEventListener('click', () => {
      document.querySelectorAll('.result').forEach((x) => x.classList.toggle('is-chosen', x === b));
      const a = ADVICE[b.dataset.result];
      advice.className = 'advice' + (a.cls ? ' ' + a.cls : '');
      advice.innerHTML = '';
      const p = document.createElement('p');
      p.textContent = a.title;
      const ul = document.createElement('ul');
      for (const item of a.items) {
        const li = document.createElement('li');
        li.textContent = item;
        ul.appendChild(li);
      }
      advice.append(p, ul);
      advice.hidden = false;
    });
  });

  // ======================================================================
  // 起動
  // ======================================================================
  (async () => {
    settings = await store.get();
    if (typeof settings.volume === 'number') $('volume').value = settings.volume;
    await refreshDevices();
    if (navigator.mediaDevices && navigator.mediaDevices.addEventListener) {
      navigator.mediaDevices.addEventListener('devicechange', refreshDevices);
    }
  })();

  window.addEventListener('pagehide', () => { stopPlaying(); if (mic.stream) stopMic(); });
})();
